import { lazy, StrictMode, Suspense } from "react";
import { createRoot } from "react-dom/client";
import "./styles.css";
import { usePos } from "./state.ts";

// Osobne paczki: kasa i kelner to oddzielne interfejsy na wspólnym backendzie.
const Kasa = lazy(() => import("./pages/Kasa.tsx"));
const Kelner = lazy(() => import("./pages/Kelner.tsx"));

function Start() {
  const s = usePos();
  // Tablet kelnerski otwiera się od razu w trybie kelnera, kasowy w trybie kasy.
  if (s.device?.kind === "waiter_tablet") location.replace("/kelner");
  else if (s.device?.kind === "pos_tablet") location.replace("/kasa");
  return (
    <div className="flex h-full items-center justify-center gap-4 bg-bottle-900 text-white">
      <a href="/kasa" className="press rounded-xl bg-white px-10 py-8 text-3xl font-semibold text-bottle-900">
        Kasa
      </a>
      <a href="/kelner" className="press rounded-xl bg-bottle-700 px-10 py-8 text-3xl font-semibold">
        Kelner
      </a>
    </div>
  );
}

function App() {
  const path = location.pathname.replace(/\/+$/, "");
  return (
    <Suspense fallback={null}>{path === "/kasa" ? <Kasa /> : path === "/kelner" ? <Kelner /> : <Start />}</Suspense>
  );
}

// Service worker: aplikacja otwiera się także bez internetu (tylko w wersji produkcyjnej).
if (import.meta.env.PROD && "serviceWorker" in navigator) {
  window.addEventListener("load", () => void navigator.serviceWorker.register("/sw.js").catch(() => undefined));
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
